import { render, staticRenderFns } from "./MealEdit.vue?vue&type=template&id=5c50e762&scoped=true&"
import script from "./MealEdit.vue?vue&type=script&lang=js&"
export * from "./MealEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c50e762",
  null
  
)

export default component.exports